import { IWorkHours } from '@cbgms/api'
import useQuery from '@cbgms/base/http/use-query'
import { getOpeningHours } from 'app/settings/state/OpeningHours/actions'
import { useDispatch } from 'react-redux'

const getOpeningHoursCacheKey = ['OPENING_HOURS']

const useGetOpeningHours = () => {
  const dispatch = useDispatch()
  return useQuery<IWorkHours | null, unknown>(getOpeningHoursCacheKey, async () => {
    const { Data } = await dispatch(getOpeningHours())
    if (Data) {
      return Data
    }

    return null
  })
}

export default useGetOpeningHours
